module.exports = __webpack_public_path__ + "static/1-65515373891685adf1c41528b54c26f9.png";